import { useNavigate } from 'react-router-dom';
import { IEventItem } from '../../interfaces/IEventItem';
import './EventItem.css';
import moment from 'moment';
import { useState } from 'react';
import MyLoader from "../UI/MyLoader/MyLoader";

const EventItem: React.FC<IEventItem> = ({
    id,
    title,
    location,
    image,
    eventDate,
    dateId
}) => {
    const navigate = useNavigate();
    const [isLoaded, setLoaded] = useState<boolean>(false);

    const isPastEvent = new Date(eventDate) < new Date();

    return (
        <div key={id} className={`eventItem ${isPastEvent ? 'pastEvent' : ''} ${isLoaded ? 'loaded' : ''}`}>
            {!isLoaded &&
                <div className='eventItem_loader'>
                    <MyLoader />
                </div>
            }

            <span className={`isLoaded ${isLoaded ? 'loaded' : ''}`}>
                <div className={`eventItem_imgWrapper`}>
                    <img
                        className='eventItem_img'
                        src={`https://minio.greenspacegg.ru:9000/meart/${image}`}
                        alt='event'
                        onLoad={() => setLoaded(true)}
                        onError={() => console.error("Ошибка загрузки изображения")}
                    />
                </div>

                <h3 className='eventItem_title' onClick={() => navigate(`/event/${id}/${dateId}`)}>
                    {title}
                </h3>

                <div className='eventItem_desc'>
                    {moment(eventDate).format('DD.MM.YYYY HH:mm')}
                </div>

                <div className='eventItem_location'>
                    <span>{location}</span>
                </div>
            </span>
        </div>
    );
};

export default EventItem;
